import { baseApi } from './baseApi';

/**
 * Permissions API endpoints
 * Handles CRUD operations for permission management
 */
export const permissionsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /permissions - Fetch all permissions
    getPermissions: builder.query({
      query: () => '/permissions',
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ right_id }) => ({ type: 'Permission', id: right_id })),
              { type: 'Permission', id: 'LIST' },
            ]
          : [{ type: 'Permission', id: 'LIST' }],
    }),

    // GET /permissions/:id - Fetch permission by ID
    getPermissionById: builder.query({
      query: (id) => `/permissions/${id}`,
      providesTags: (result, error, id) => [{ type: 'Permission', id }],
    }),

    // POST /permissions - Create new permission
    createPermission: builder.mutation({
      query: (permissionData) => ({
        url: '/permissions',
        method: 'POST',
        body: permissionData,
      }),
      invalidatesTags: [{ type: 'Permission', id: 'LIST' }],
    }),

    // PATCH /permissions/:id - Update permission
    // Note: Fixed typo from original saga (was /persmissions/:id)
    updatePermission: builder.mutation({
      query: ({ id, ...permissionData }) => ({
        url: `/permissions/${id}`,
        method: 'PATCH',
        body: permissionData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Permission', id },
        { type: 'Permission', id: 'LIST' },
      ],
    }),

    // DELETE /permissions/:id - Delete permission
    deletePermission: builder.mutation({
      query: (id) => ({
        url: `/permissions/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'Permission', id },
        { type: 'Permission', id: 'LIST' },
      ],
    }),
  }),
});

// Export hooks for use in components
export const {
  useGetPermissionsQuery,
  useGetPermissionByIdQuery,
  useCreatePermissionMutation,
  useUpdatePermissionMutation,
  useDeletePermissionMutation,
} = permissionsApi;

